// extracted by mini-css-extract-plugin
export default {"consent":"CookieModal_consent__fJUcV","consentGrid":"CookieModal_consentGrid__gkFQs","buttonGrid":"CookieModal_buttonGrid__boapf","consentModal":"CookieModal_consentModal__+Oc+D"};